import { KText } from '@/ui-library/components';
import {
  CreatedBy,
  CreditedTo,
  NameCell,
  SourceName,
} from '../cells/ContactDrilldownCells';

const renderDrilldownHeader = (title: string) => {
  const DrilldownHeader = () => (
    <KText size="sm-medium" color="secondary-900" textTransform="none">
      {title}
    </KText>
  );
  return DrilldownHeader;
};

export const useContactDrilldownConfig = ({
  drilldownHeading = 'Candidates',
  onSort: _onSort = () => {},
  currentSort: _currentSort = {},
}) => {
  const getColumnConfig = () => {
    const columnsMap = {
      contactName: {
        title: 'Candidate name',
        columnConfig: false,
        Header: renderDrilldownHeader('Candidate name'),
        id: 'candidate_name',
        minWidth: 200,
        accessor: 'contact',
        sort: true,
        Cell: ({ row }) => NameCell(row),
      },
      sourceName: {
        title: 'Source',
        Header: renderDrilldownHeader('Source'),
        minWidth: 200,
        accessor: 'source',
        sort: true,
        Cell: ({ row }) => SourceName(row),
      },
      creditedTo: {
        title: 'Credited to',
        Header: renderDrilldownHeader('Credited to'),
        minWidth: 200,
        accessor: 'credited_to',
        sort: true,
        Cell: ({ row }) => CreditedTo(row),
      },
      createdBy: {
        title: 'Created by',
        Header: renderDrilldownHeader('Created by'),
        minWidth: 180,
        accessor: 'created_by',
        sort: true,
        Cell: ({ row }) => CreatedBy(row),
      },
    };

    const contactDrilldownColumns = [
      columnsMap.contactName,
      columnsMap.sourceName,
      columnsMap.creditedTo,
      columnsMap.createdBy,
    ];

    switch (drilldownHeading) {
      case 'New candidates':
      case 'Sourced':
      case 'Inbound':
      case 'Referral':
      case 'New candidate trend by source (on candidate)':
      case 'Candidates':
        return contactDrilldownColumns;

      case 'New candidate trend by source':
        return contactDrilldownColumns;

      default:
        return contactDrilldownColumns;
    }
  };

  return { columnConfig: getColumnConfig() };
};
